import { render } from "./MouseTracker.vue?vue&type=template&id=be1d5698"
import script from "./MouseTracker.vue?vue&type=script&lang=js"
export * from "./MouseTracker.vue?vue&type=script&lang=js"

import "./MouseTracker.vue?vue&type=style&index=0&id=be1d5698&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__